const animatedWaveWrappers = document.querySelectorAll('.waves-wrapper');

if (animatedWaveWrappers.length > 0) {
	animatedWaveWrappers.forEach((wavesWrapper) => {
		// console.log(wavesWrapper);
		const paths = wavesWrapper.querySelectorAll('path');
		let delayFactor = 0;
		for (let i = 0; i < paths.length / 2; i++) {
			// let delayFactor = 0;
			paths[i].style.animationDelay = `${delayFactor}s`;
			delayFactor += 0.4;
		}
		delayFactor = 0;
		for (let i = paths.length - 1; i > paths.length / 2; i--) {
			// let delayFactor = 0;
			paths[i].style.animationDelay = `${delayFactor}s`;
			delayFactor += 0.4;
		}
	});
}
